"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[491],{

/***/ 1491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ulupinar_page_head_UlupinarPageHead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
;// CONCATENATED MODULE: ./components/widgets/ulupinar-page-head/UlupinarPageHead.tsx





var UlupinarPageHead = function(param) {
    var title = param.title, thumbnail = param.thumbnail;
    var app = (0,contexts_app/* useApp */.qD)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "UlupinarPageHead",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "thumbnail",
            style: {
                background: "url('".concat(utils/* path.asset */.E.asset(app.environment, thumbnail.src), "')")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
                size: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                        xs: {
                            size: 12
                        },
                        sm: {
                            size: 12
                        },
                        md: {
                            size: 12
                        },
                        lg: {
                            size: 12
                        },
                        xl: {
                            size: 12
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title",
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ var ulupinar_page_head_UlupinarPageHead = (UlupinarPageHead);

;// CONCATENATED MODULE: ./components/widgets/ulupinar-page-head/index.ts



/***/ })

}]);